import Call from '../../Call.v2';

const Offers = {
    get() {
        return Call(`dating/offers`);
    },

    save(event) {
        return Call(`dating/offers`, 'POST', event);
    },

    update(id, event) {
        return Call(`dating/offers/${id}`, 'PUT', event);
    },

    remove(id) {
        return Call(`dating/offers/${id}`, 'DELETE');
    },
};

export default Offers;


// WEBPACK FOOTER //
// ./src/services/API/components/Dating/Offers.js